//首页业界一流团队为您服务模块

import React from "react";

import Img from "gatsby-image";
import { useStaticQuery, graphql } from "gatsby";


import { OverPack } from 'rc-scroll-anim';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';

import * as styles from "./index.module.scss";
import { useI18n } from "@src/i18n";

const ServiceGroup = () => {
  const { t } = useI18n();
  const data = useStaticQuery(graphql`
    query {
      service1: file(relativePath: { eq: "service1.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 284) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      service2: file(relativePath: { eq: "service2.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 284) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      service3: file(relativePath: { eq: "service3.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 284) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      service4: file(relativePath: { eq: "service4.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 284) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      service1Icon: file(relativePath: { eq: "service1Icon.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 48) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      service2Icon: file(relativePath: { eq: "service2Icon.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 48) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      service3Icon: file(relativePath: { eq: "service3Icon.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 48) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      service4Icon: file(relativePath: { eq: "service4Icon.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 48) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  const serviceDatas = [
    {
      title: t("home.serviceGroup.items.0.title"),
      imgPath: data.service1.childImageSharp.fluid,
      details: t("home.serviceGroup.items.0.details"),
      iconPath: data.service1Icon.childImageSharp.fluid,
    },
    {
      title: t("home.serviceGroup.items.1.title"),
      imgPath: data.service2.childImageSharp.fluid,
      details: t("home.serviceGroup.items.1.details"),
      iconPath: data.service2Icon.childImageSharp.fluid,
    },
    {
      title: t("home.serviceGroup.items.2.title"),
      imgPath: data.service3.childImageSharp.fluid,
      details: t("home.serviceGroup.items.2.details"),
      iconPath: data.service3Icon.childImageSharp.fluid,
    },
    {
      title: t("home.serviceGroup.items.3.title"),
      imgPath: data.service4.childImageSharp.fluid,
      details: t("home.serviceGroup.items.3.details"),
      iconPath: data.service4Icon.childImageSharp.fluid,
    },
  ];
  return (
    <div className={styles.serviceGroupContainer}>
      <OverPack playScale={[0.2]}>
        <QueueAnim type='bottom'>
          <div className={styles.title} key='title'>{t("home.serviceGroup.title")}</div>
          <div className={styles.cardGroup} key='group'>
            {serviceDatas.map((item, index) => {
              return (
                <div className={styles.cardContainer} key={index}>
                  <Img
                    fluid={item.imgPath}
                    className={styles.innerImg}
                    alt={item.title}
                  />
                  <div className={styles.slide}>
                    <Img
                      fluid={item.iconPath}
                      className={styles.iconImg}
                      alt={item.title}
                    />
                    <div className={styles.serviceName}>{item.title}</div>
                    <div className={styles.mask}>
                      <div className={styles.center}>
                        {item.details.map((item) => (
                          <div key={item}>{item}</div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </QueueAnim>
      </OverPack>


    </div>
  );
};

export default ServiceGroup;
